import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import DOMPurify from 'dompurify'
import getGameRuleService from 'services/article/getGameRule'
import styles from 'layouts/appView/layout.module.sass'

function GameRule() {
  const dispatch = useDispatch()
  const [content, setContent] = useState('')

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await dispatch(getGameRuleService())
        setContent(DOMPurify.sanitize(data.content))
      } catch (error) {
        //
      }
    }
    fetchData()
  }, [dispatch])

  return (
    <div
      className={styles.innerHtml}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: content }}
    />

  )
}

export default GameRule
